<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/piedmont')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/bruno-giacosa')">Bruno Giacosa
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/italy/piedmont/cantina-roberto-voerzio')">Cantina Roberto
                        Voerzio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/conterno-fantino')">Conterno Fantino
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/g-d-vajra')">G. D. Vajra
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/gaja')">Gaja
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/giacomo-conterno')">Giacomo Conterno
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/giuseppe-mascarello-e-figlio')">Giuseppe
                        Mascarello e Figlio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/massolino')">Massolino
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/poderi-aldo-conterno')">Poderi Aldo Conterno
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/roagna')">Roagna
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/tenuta-la-giustiniana')">Tenuta La
                        Giustiniana
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/vigne-marina-coppi')">Vigne Marina Coppi
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/piedmont')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Cantina Roberto Voerzio</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Uno dei più grandi vini rossi del mondo, il Barolo è l'unico vino italiano che può comandare lo stesso
                        rispetto come dire Bordeaux o Borgogna. È un vino tradizionalista, corposo, caratteristico,
                        ricco di tannini (quindi perfetto per un lungo invecchiamento) e di straordinaria qualità. Quindi potrebbe sembrare un po 'a
                        sorpresa di trovare un giovane enologo con una visione essenzialmente semplice che domina un posto
                        Il barolo protagonista.
                    </div>

                    <div class="howto-title2">Produzione più bassa in Piemonte</div>
                    <div class="howto-text">
                        Fondato nel solo 1986, Roberto Voerzio è spesso considerato con la moderna scuola del Barolo,
                        anche se nulla potrebbe allontanarsi dalla verità. Citando tra questi Bruno Giacosa e Giovanni Conterno
                        suoi eroi, aderisce ai principi tradizionali dell'enologo italiano come il lungo invecchiamento in
                        botte (o botti). A questo aggiunge la sua firma: rese incredibilmente basse e meticolosamente
                        vitigni mantenuti che equivalgono a vini che hanno un sapore fresco nonostante due decenni di invecchiamento. Optando per
                        vini di singole vigne ove possibile (ne ha ben sette in portafoglio, anche se
                        sarebbe molto raro che tutti e sette uscissero nella stessa annata), la sua spinta per
                        la perfezione è rara, anche tra i piemontesi esigenti. I rendimenti bassi sono naturalmente uguali a quelli bassi
                        produzione ma Voerzio è forse tra i più bassi di tutti - vengono rilasciati solo 150-450 casi
                        ogni anno, rendendo questo uno dei vini più ambiti d'Italia.
                    </div>

                    <div class="howto-title2">Uno dei migliori vini italiani del pianeta</div>
                    <div class="howto-text">
                        Voerzio ha appena 22 ettari nei migliori siti di La Morra, che gli regalano una collezione di grand cru
                        vigneti abbinati da pochi viticoltori. La sua vigilanza nei campi gli ha fatto guadagnare la reputazione di
                        offrendo l'espressione più pura possibile del Nebbiolo, e non ci vuole un enologo per vedere
                        che fin dalla prima annata i suoi vini sono semplicemente stupendi. Il suo Barolo Sarmassa di
                        Il Barolo ha guadagnato ben 98 punti dal Vinous di Antonio Galloni, mentre altre annate
                        segnare costantemente negli anni '90. Non sorprende che questi non siano economici: quelli di Roberto
                        notorietà e stima da parte della critica, insieme alla piccola produzione fanno dei suoi Barolo alcuni dei
                        le bottiglie più costose e collezionabili al mondo.
                    </div>

                    <div class="howto-title2">Fatti e annate notevoli</div>
                    <div class="howto-text">
                        <ul>
                            <li>Nel 2007, Roberto Voerzio, ha iniziato una tendenza tra i migliori produttori quando ha presentato il suo Barolo
                                Fossati Case Nere 10 Anni Riserva 2003 rilasciato nel 2013. La produzione è limitata, nella media
                                3.000-4.000 bottiglie solo nelle annate adeguate. Negli ultimi anni, i prezzi per tutti
                                le annate si sono spostate verso l'alto e l'uscita è prevista per la fine del 2019, un singolo (in
                                bond) bottiglia dell'annata 2009 costerà agli investitori quasi € 600.
                            </li>
                            <li>La “Top 100 Italian Wines 2018” di James Suckling colloca il Barolo Cerequio 2014 di Roberto Voerzio al numero 53, prezzi in aumento di oltre il +25% nell’arco di un anno da giugno 2018.
                            </li>
                            <li>Con il suo approccio “modernista” in vigna e tattiche “fusioniste” in cantina,
                                Roberto Voerzio è stato uno degli originali "Barolo Boys" - termine coniato dal New York
                                Times nel 1990 (e successivamente titolo del documentario del 2014) come la generazione che, nel
                                la fine degli anni ottanta ha spinto il loro vino piemontese alla fama mondiale, rivoluzionando al tempo stesso
                                cose nelle Langhe.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Cantina Roberto Voerzio</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Barolo ist einer der größten Rotweine der Welt und der einzige italienische Wein, der das Gleiche erreichen kann
                        Respekt wie Bordeaux oder Burgund. Es ist ein Traditionalistenwein, vollmundig, unverwechselbar,
                        Reich an Tanninen (also perfekt für eine lange Reifung) und von enormer Qualität. Es könnte also ein bisschen wie ein... kommen
                        Überraschung, einen jungen Winzer mit einer im Wesentlichen einfachen Vision zu finden, der einen Platz einnimmt
                        Barolos Mittelpunkt.
                    </div>

                    <div class="howto-title2">Niedrigste Produktion im Piemont</div>
                    <div class="howto-text">
                        Roberto Voerzio wurde erst 1986 gegründet und wird oft mit der modernen Schule des Barolo in Verbindung gebracht.
                        obwohl nichts weiter von der Wahrheit entfernt sein könnte. Unter Berufung auf Bruno Giacosa und Giovanni Conterno
                        Als seine Vorbilder hält er sich an die traditionellen Prinzipien des italienischen Winzers wie die lange Reifung
                        Fass (oder Botti). Dazu kommt sein Markenzeichen: traumhaft niedrige Erträge und akribische Sorgfalt
                        gepflegte Reben, die Weine ergeben, die trotz zwei Jahrzehnten Lagerung im Keller frisch schmecken. Sich dafür entscheiden
                        Weine aus einzelnen Weinbergen, wenn möglich (er hat bis zu sieben in seinem Portfolio, obwohl es
                        Es wäre sehr ungewöhnlich, dass alle sieben im selben Jahrgang erscheinen würden), sein Streben danach
                        Perfektion ist selten, selbst unter den anspruchsvollen Piemontesern. Niedrige Erträge bedeuten natürlich auch niedrige Erträge
                        Produktion, aber Voerzio gehört vielleicht zu den niedrigsten von allen – nur 150–450 Fälle werden freigegeben
                        Jedes Jahr wird dieser Wein zu einem der begehrtesten Weine Italiens.
                    </div>

                    <div class="howto-title2">Einer der besten italienischen Weine der Welt</div>
                    <div class="howto-text">
                        Voerzio verfügt über nur 22 Hektar Land in den besten Lagen von La Morra, was ihm eine Sammlung von Grand Cru beschert
                        Weinberge, die von wenigen Winzern übertroffen werden. Seine Wachsamkeit auf den Feldern hat ihm den Ruf eingebracht
                        Es liefert den reinsten Ausdruck von Nebbiolo, der möglich ist, und es ist kein Önologe erforderlich, um dies zu erkennen
                        dass seine Weine vom ersten Jahrgang an einfach großartig sind. Sein 2000er Barolo Sarmassa di
                        Der Barolo erhielt von Antonio Gallonis Vinous und anderen Jahrgängen satte 98 Punkte
                        punktet konstant im hohen 90er-Bereich. Es überrascht nicht, dass diese nicht billig sind: Robertos
                        Der Ruf und die hohe Wertschätzung der Kritiker sowie die geringe Produktion machen seine Barolos zu etwas Besonderem
                        die teuersten und sammelwürdigsten Flaschen der Welt.
                    </div>

                    <div class="howto-title2">Bemerkenswerte Fakten und Jahrgänge</div>
                    <div class="howto-text">
                        <ul>
                            <li>Im Jahr 2007 löste Roberto Voerzio mit der Vorstellung seines Barolo einen Trend unter den Top-Produzenten aus
                                Fossati Case Nere 10 Anni Riserva 2003 erschien 2013. Die Produktion ist knapp und mittelmäßig
                                3.000-4.000 Flaschen nur in geeigneten Jahren. Seit einigen Jahren gelten die Preise für alle
                                Die Jahrgänge haben zugenommen und sollen später im Jahr 2019 veröffentlicht werden, eine Single (in
                                Eine Flasche Jahrgang 2009 kostet Anleger fast 600 Euro.
                            </li>
                            <li>James Sucklings „Top 100 italienische Weine 2018“ platzierten Roberto Voerzios 2014 Barolo Cerequio auf Platz 53, wobei die Preise im Einjahreszeitraum ab Juni 2018 um mehr als +25 % stiegen.
                            </li>
                            <li>Mit seinem „modernistischen“ Ansatz im Weinberg und seinen „fusionistischen“ Taktiken im Keller,
                                Roberto Voerzio war einer der ursprünglichen „Barolo Boys“ – ein Begriff, der von den New Yorkern geprägt wurde
                                Times im Jahr 1990 (und späterer Titel des Dokumentarfilms von 2014) als die Generation, die in der
                                Die späten Achtzigerjahre verhalfen ihrem Piemonte-Wein zu weltweitem Ruhm und revolutionierten ihn zugleich
                                Dinge in der Langhe.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Cantina Roberto Voerzio</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        L'un des plus grands vins rouges du monde, Barolo est le seul vin italien qui peut commander le même
                        respect comme disent Bordeaux ou Bourgogne. C'est un vin de tradition, corsé, typé,
                        riche en tanins (donc parfait pour un long vieillissement) et d'une qualité exceptionnelle. Cela peut donc venir un peu
                        surprise de trouver un jeune vigneron avec une vision essentiellement simple commandant une place sur
                        La scène centrale de Barolo.
                    </div>

                    <div class="howto-title2">La plus faible production du Piémont</div>
                    <div class="howto-text">
                        Fondé en seulement 1986, Roberto Voerzio est souvent considéré avec l'école moderne de Barolo,
                        bien que rien ne puisse être plus éloigné de la vérité. Citant Bruno Giacosa et Giovanni Conterno parmi
                        ses héros, il adhère aux principes traditionnels du vigneron italien tels que le long vieillissement en
                        tonneau (ou botti). À cela, il ajoute sa signature : des rendements incroyablement bas et méticuleusement
                        des vignes entretenues qui égalent des vins qui ont un goût frais malgré deux décennies de cave. Opter pour
                        vins de vignoble unique si possible (il en a jusqu'à sept dans son portefeuille, bien qu'il
                        serait très rare que les sept sortent tous dans le même millésime), sa volonté de
                        la perfection est rare, même chez les Piémontais exigeants. Les rendements faibles sont naturellement égaux
                        production mais Voerzio est peut-être parmi les plus bas de tous - seuls 150 à 450 cas sont sortis
                        chaque année, ce qui en fait l'un des vins les plus convoités d'Italie.
                    </div>

                    <div class="howto-title2">L'un des meilleurs vins italiens de la planète</div>
                    <div class="howto-text">
                        Voerzio ne possède que 22 hectares dans les plus beaux sites de La Morra, ce qui lui donne une collection de grands crus
                        vignobles égalés par quelques viticulteurs. Sa vigilance dans les champs lui a valu la réputation de
                        délivrant l'expression la plus pure possible du Nebbiolo, et il n'est pas nécessaire d'être œnologue pour voir
                        que dès le premier millésime ses vins sont tout simplement magnifiques. Son Barolo Sarmassa di 2000
                        Barolo a gagné un énorme 98 points de Vinous d'Antonio Galloni, tandis que d'autres millésimes
                        score systématiquement dans les années 90. Sans surprise, ceux-ci ne sont pas bon marché: Roberto's
                        la réputation et la haute estime des critiques, ainsi que la petite production font de ses Barolos l'un des
                        les bouteilles les plus chères et les plus collectionnables au monde.
                    </div>

                    <div class="howto-title2">Faits marquants et millésimes</div>
                    <div class="howto-text">
                        <ul>
                            <li>En 2007, Roberto Voerzio a lancé une tendance parmi les meilleurs producteurs en dévoilant son Barolo
                                Fossati Case Nere 10 Anni Riserva 2003 sorti en 2013. La production est serrée, en moyenne
                                3 000 à 4 000 bouteilles uniquement les années appropriées. Depuis quelques années, des prix pour tous
                                les millésimes ont augmenté et devraient sortir plus tard en 2019, un single (en
                                bond) bouteille du millésime 2009 coûtera près de 600 € aux investisseurs.
                            </li>
                            <li>Le "Top 100 des vins italiens 2018" de James Suckling a placé le Barolo Cerequio 2014 de Roberto Voerzio au numéro 53, les prix ayant augmenté de plus de +25 % sur la période d'un an à partir de juin 2018.
                            </li>
                            <li>Avec son approche «moderniste» dans le vignoble et sa tactique «fusionniste» dans la cave,
                                Roberto Voerzio était l'un des premiers "Barolo Boys" - un terme inventé par le New York
                                Times en 1990 (et titre ultérieur du documentaire de 2014) alors que la génération qui, dans le
                                la fin des années 80 a propulsé son vin Piemonte à la renommée mondiale tout en révolutionnant
                                choses dans les Langhe.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Cantina Roberto Voerzio</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        One of the world’s greatest red wines, Barolo is the only Italian wine that can command the same
                        respect as say Bordeaux or Burgundy. It is a traditionalist’s wine, full-bodied, distinctive,
                        tannin-rich (so perfect for long ageing) and tremendous in quality. So it may come as a bit of a
                        surprise to find a young winemaker with an essentially simple vision commanding a place on
                        Barolo’s centre stage.
                    </div>

                    <div class="howto-title2">Lowest production in Piedmont</div>
                    <div class="howto-text">
                        Founded in just 1986, Roberto Voerzio is often considered with the modern school of Barolo,
                        although nothing could further from the truth. Citing Bruno Giacosa and Giovanni Conterno among
                        his heroes, he adheres to the Italian winemaker’s traditional principles such as long ageing in
                        cask (or botti). To this he adds his signature: fantastically low yields and meticulously
                        maintained vines that equal wines that taste fresh despite two decades of cellaring. Opting for
                        single vineyard wines where possible (he has as many as seven in his portfolio, although it
                        would be very uncommon for all seven to be released in the same vintage), his drive for
                        perfection is rare, even among the demanding Piedmontese. Low yields naturally equal low
                        production but Voerzio is perhaps among the lowest of them all - just 150-450 cases are released
                        each year, making this one of Italy’s most covetable wines.
                    </div>

                    <div class="howto-title2">One of the best Italian wines on the planet</div>
                    <div class="howto-text">
                        Voerzio has just 22-hectares in La Morra’s finest sites, giving him a collection of grand cru
                        vineyards matched by few growers. His vigilance in the fields has earned him the reputation of
                        delivering the purest expression of Nebbiolo possible, and it does not take an oenologist to see
                        that from the very first vintage his wines are simply gorgeous. His 2000 Barolo Sarmassa di
                        Barolo earnt a massive 98 points from Antonio Galloni’s Vinous, while other vintages
                        consistently score in the high 90s. Unsurprisingly, these do not come cheap: Roberto’s
                        reputation and high regard by critics, along with the tiny production make his Barolos some of
                        the most expensive and collectable bottles in the world.
                    </div>

                    <div class="howto-title2">Notable facts and vintages</div>
                    <div class="howto-text">
                        <ul>
                            <li>In 2007, Roberto Voerzio, began a trend among top producers when he unveiled his Barolo
                                Fossati Case Nere 10 Anni Riserva 2003 released in 2013. Production is tight, averaging
                                3,000-4,000 bottles only in appropriate years. For the past few years, prices for all
                                vintages have been moving upwards and slated for release later in 2019, a single (in
                                bond) bottle of 2009 vintage will set investors back nearly €600.
                            </li>
                            <li>James Suckling’s “Top 100 Italian Wines 2018” placed Roberto Voerzio’s 2014 Barolo Cerequio at number 53, prices on the rise by more than +25% in the one year period from June 2018.
                            </li>
                            <li>With his “modernist” approach in the vineyard and “fusionist” tactics in the cellar,
                                Roberto Voerzio was one of the original "Barolo Boys” - a term coined by the New York
                                Times in 1990 (and later title of the 2014 documentary) as the generation who, in the
                                late eighties propelled their Piemonte wine to worldwide fame while revolutionising
                                things in Langhe.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CantinaRobertoVoerzio",
    head: {
        title: 'Cantina Roberto Voerzio | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the world-renowned wines of Cantina Roberto Voerzio, a premier wine producer located in the heart of the Piedmont wine region in Italy. Experience the blend of traditional winemaking techniques and modern innovation in each bottle.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Cantina Roberto Voerzio', src: '/wine-guide/italy/piedmont/cantina-roberto-voerzio'},
            items: [
                {report: 'Bruno Giacosa', src: '/wine-guide/italy/piedmont/bruno-giacosa'},
                {report: 'Cantina Roberto Voerzio', src: '/wine-guide/italy/piedmont/cantina-roberto-voerzio'},
                {report: 'Conterno Fantino', src: '/wine-guide/italy/piedmont/conterno-fantino'},
                {report: 'G. D. Vajra', src: '/wine-guide/italy/piedmont/g-d-vajra'},
                {report: 'Gaja', src: '/wine-guide/italy/piedmont/gaja'},
                {report: 'Giacomo Conterno', src: '/wine-guide/italy/piedmont/giacomo-conterno'},
                {
                    report: 'Giuseppe Mascarello e Figlio',
                    src: '/wine-guide/italy/piedmont/giuseppe-mascarello-e-figlio'
                },
                {report: 'Massolino', src: '/wine-guide/italy/piedmont/massolino'},
                {report: 'Poderi Aldo Conterno', src: '/wine-guide/italy/piedmont/poderi-aldo-conterno'},
                {report: 'Roagna', src: '/wine-guide/italy/piedmont/roagna'},
                {report: 'Tenuta La Giustiniana', src: '/wine-guide/italy/piedmont/tenuta-la-giustiniana'},
                {report: 'Vigne Marina Coppi', src: '/wine-guide/italy/piedmont/vigne-marina-coppi'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
